import React from 'react';
import { XCircle, MapPinOff, RefreshCw } from 'lucide-react';

interface PortalGuruModalErrorProps {
    title?: string;
    message: string;
    onClose: () => void;
    onRetry?: () => void;
    /** Ringkasan diagnosis kecepatan (kecil, untuk dilaporkan bila lambat). */
    diagnostic?: string;
}

export const PortalGuruModalError: React.FC<PortalGuruModalErrorProps> = ({ title = 'Terjadi Kesalahan', message, onClose, onRetry, diagnostic }) => {
    return (
        <div className="fixed inset-0 z-[110] flex items-center justify-center px-4">
            <div className="absolute inset-0 bg-gray-900/60 backdrop-blur-sm transition-opacity" onClick={onClose}></div>
            <div className="relative w-full max-w-sm bg-white rounded-3xl p-6 shadow-2xl ring-1 ring-white/10 transform transition-all animate-in slide-in-from-bottom-10 fade-in duration-300 text-center">
                <div className="mx-auto w-20 h-20 rounded-full bg-red-100 flex items-center justify-center mb-6 ring-8 ring-red-50">
                    <MapPinOff size={40} className="text-red-600" />
                </div>
                <h3 className="text-xl font-bold text-[#111813] tracking-tight mb-2">{title}</h3>
                <p className="text-sm text-gray-600 mb-8 leading-relaxed">
                    {message}
                </p>

                <div className="flex gap-3">
                    <button
                        onClick={onClose}
                        className="flex-1 py-3 bg-gray-100 hover:bg-gray-200 text-gray-700 font-bold rounded-xl transition-colors"
                    >
                        Tutup
                    </button>
                    {onRetry && (
                        <button
                            onClick={onRetry}
                            className="flex-1 py-3 bg-[#40513B] hover:bg-[#344230] text-white font-bold rounded-xl shadow-lg shadow-[#40513B]/20 transition-all flex items-center justify-center gap-2"
                        >
                            <RefreshCw size={18} /> Coba Lagi
                        </button>
                    )}
                </div>
                {diagnostic && (
                    <p className="mt-3 text-[9px] leading-snug text-gray-400 font-mono break-words">{diagnostic}</p>
                )}
            </div>
        </div>
    );
};
